<template>
  <section class="wrapper">
    <aside class="company-info">
      <span>{{companyName}}</span>
      <span @click="changeCompany"><i class="iconfont iconfont-qiehuan"></i> 切换</span>
    </aside>
    <!--图表-->
    <aside class="chart-wrapper">
      <div id="chart" class="chart"></div>
      <van-grid :column-num="3" :border="false">
        <van-grid-item>
          <h3 class="text-primary">25036.05<i class="h6 text-lightgray">元</i></h3>
          <h6 class="text-lightgray">本月至今净利润</h6>
        </van-grid-item>
        <van-grid-item text="153.08">
          <h3 class="text-primary">153.08<i class="h6 text-lightgray">元</i></h3>
          <h6 class="text-lightgray">本年至今净现金流</h6>
        </van-grid-item>
        <van-grid-item text="43506.85">
          <h3 class="text-primary">43506.85<i class="h6 text-lightgray">元</i></h3>
          <h6 class="text-lightgray">应收款总金额</h6>
        </van-grid-item>
      </van-grid>
    </aside>
    <!--行政办公-->
    <aside class="business-panel">
      <h5 class="text-muted">行政办公</h5>
      <div class="menu">
        <span class="item" @click="$router.push('/approval/index')">待审批
          <van-badge :content="approvalCount"/>
        </span>
        <span class="item" @click="$router.push('/follow')">流程</span>
      </div>
    </aside>
    <!--常用功能-->
    <aside class="common-panel">
      <h5 class="text-muted">常用功能</h5>
      <van-grid class="menu" :column-num="4" :border="false">
        <van-grid-item badge="99+">
          <van-badge :content="5">
            <img src="../assets/img/todo.png" alt="" style="width:3rem;">
          </van-badge>
          <h6 class="mt5 text-muted">待办事项</h6>
        </van-grid-item>
        <van-grid-item>
          <img src="../assets/img/bgcenter.png" alt="" style="width:3rem;">
          <h6 class="mt5 text-muted">通知事件</h6>
        </van-grid-item>
        <van-grid-item>
          <img src="../assets/img/report.png" alt="" style="width:3rem;">
          <h6 class="mt5 text-muted">报告中心</h6>
        </van-grid-item>
        <van-grid-item>
          <img @click="$router.push('/OfficeCheck')" src="../assets/img/areasing.png" alt="" style="width:3rem;">
          <h6 class="mt5 text-muted" @click="$router.push('/OfficeCheck')">考勤打卡</h6>
        </van-grid-item>
      </van-grid>
      <van-grid class="menu" :column-num="4" :border="false">
        <van-grid-item>
            <img @click="getdidiurl('0')" src="../assets/img/car.png" alt="" style="width:3rem;">
          <h6 class="mt5 text-muted" @click="getdidiurl('0')">用车</h6>
        </van-grid-item>
        <van-grid-item>
          <img @click="getdidiurl('1')" src="../assets/img/hotel.png" alt="" style="width:3rem;">
          <h6 class="mt5 text-muted" @click="getdidiurl('1')">酒店</h6>
        </van-grid-item>
        <van-grid-item>
          <img @click="getdidiurl('2')" src="../assets/img/plane.png" alt="" style="width:3rem;">
          <h6 class="mt5 text-muted" @click="getdidiurl('2')">机票</h6>
        </van-grid-item>
        <van-grid-item>
          <img @click="getdidiurl('3')" src="../assets/img/tran.png" alt="" style="width:3rem;">
          <h6 class="mt5 text-muted" @click="getdidiurl('3')">火车票</h6>
        </van-grid-item>
      </van-grid>
    </aside>
  </section>
</template>

<script>
  import Footer from "./layout/components/Footer";
  import * as echarts from 'echarts';
  import {getApprovalListApi,getLoginEncryptStr} from '@/api/reimbursement'

  export default {
    components: {
      Footer
    },
    data() {
      return {
        approvalCount:0,
        companyName:"",
      }
    },
    created() {
      let companyInfo=this.getCookie("CompanyInfo");
      if(companyInfo==null){
        this.$router.push('/company');
        return;
      }
      if(companyInfo.companyId==null||companyInfo.companyId==""){
        this.$router.push('/company');
        return;
      }
    },
    mounted() {
      this.getLoginInfo();
      this.createEChart();
      this.getApprovalList();
    },
    methods: {
      async getdidiurl(product_type) {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cguid: companyInfo.companyId,
          ucguid: userInfo.U_GUID,
          product_type:product_type
        };
        // 1. 打印调试信息
        try {
          let response = await getLoginEncryptStr(params)
          if (response.success) {
            if (response.code === "0000") {
              window.location.href = response.result; // 直接跳转
              return;
            }
            this.$toast.fail(response.msg);
            // return;
          }
        } catch (error) {
          console.error('跳转失败:', error)
          this.$toast.fail(error.message || '跳转失败')
        } finally {
          this.checkingItemId = null
        }
      },
      getLoginInfo(){
        let companyInfo=this.getCookie("CompanyInfo");
        if(companyInfo!=null){
          this.$set(this,"companyName",companyInfo.companyName);
        }
      },
      //初始化图表
      createEChart() {
        let myChart = echarts.init(document.getElementById('chart'));
        myChart.setOption({
          grid: {
            bottom: 20,
            right: 0,
            top: 30
          },
          legend: {
            data: ['计划用量', '实际用量']
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#bebebe',
                fontSize: 12
              },
              data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            }
          ],
          yAxis: [
            {
              type: 'value',
              min: 0,
              max: 250,
              axisLabel: {
                textStyle: { // 文字样式
                  color: '#bebebe',
                  fontSize: 12
                }
              },
              splitLine: false
            },
            {
              type: 'value',
              min: 0,
              max: 25,
              interval: 5,
              show: false,
            }
          ],
          series: [
            {
              name: '计划用量',
              type: 'bar',
              tooltip: {
                valueFormatter: function (value) {
                  return value + ' ml';
                }
              },
              showBackground: true,//是否显示柱条的背景色
              backgroundStyle: {
                color: 'rgba(220, 220, 220, 0.3)'
              },
              itemStyle: {
                borderRadius: [3, 3, 3, 3], // 设置柱状图圆角
                color: {
                  type: 'linear',
                  x: 0,
                  y: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#3597cf',
                    },
                    {
                      offset: 1,
                      color: '#48d1d6',
                    },
                  ],
                  global: false
                }
              },
              data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3]
            },
            {
              name: '实际用量',
              type: 'line',
              yAxisIndex: 1,
              tooltip: {
                valueFormatter: function (value) {
                  return value + ' °C';
                }
              },
              itemStyle: {
                color: '#74db9a'
              },
              data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
            }
          ]
        });
      },
      changeCompany() {
        this.$router.push('/company')
      },
      //获取待审批列表
      async getApprovalList() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo=this.getCookie("CompanyInfo");
        if(userInfo!=null&&companyInfo!=null){
          let params = {
            formType:"",
            cGuid: companyInfo.companyId,
            uGuid: userInfo.U_GUID,
            applyUGuid:""
          };
          let response = await getApprovalListApi(params);
          if (response.success) {
            if(response.code==="0000") {
              this.approvalCount = response.result.length;
            }
          }
        }
      },
      goto(url) {
        this.$router.push(url)
      }
    }
  }
</script>
<style lang="less" scoped>
  .wrapper {
    background: #E9F2F2;
    min-height: calc(100vh - 100px); /* 总高度 - Footer 高度 */
    padding-bottom: 100px; /* 补偿 */
    overflow-y: auto;

    .company-info {
      height: 20rem;
      line-height: 5rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      justify-items: center;
      background: #1fb1c4;
      color: white;
      font-size: 1.6rem;
      padding: 0 1.5rem;
      border-radius: 0 0 50% 50%;
    }

    .chart-wrapper {
      width: calc(100% - 3rem);
      height: 25rem;
      margin: -15rem 1.5rem 0 1.5rem;
      padding: 1rem;
      border-radius: 5px;
      /*position: absolute;*/
      /*top: 8rem;*/
      background: white;
      box-sizing: border-box;

      .chart {
        width: 100%;
        height: 15rem;
      }
    }

    .business-panel {
      padding: 1.5rem;

      .menu {
        display: flex;
        margin-top: 1rem;

        .item {
          flex: 1;
          color: white;
          font-size: 1.4rem;
          height: 6rem;
          line-height: 6rem;
          padding: 0 1rem;
          position: relative;

          &:first-child {
            background: linear-gradient(90deg, #1771ca 0%, #92c3df 100%);
            border-radius: 5px;
          }

          &:last-child {
            background: linear-gradient(90deg, #0baabf 0%, #84d1db 100%);
            border-radius: 5px;
            margin-left: 1rem;
          }

          &:after {
            font-family: 'iconfont';
            content: '\e612';
            color: #1fb1c4;
            position: absolute;
            right: .85rem;
            font-size: 1.2rem;
          }

          &:before {
            width: 1.5rem;
            height: 1.5rem;
            content: '';
            position: absolute;
            right: .7rem;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 50%;
            background: rgba(255, 255, 255, .5)
          }
        }
      }
    }

    .common-panel {
      padding: 0 1.5rem;

      .menu {
        background: white;
        margin-top: 1rem;
      }
    }
  }
</style>

